import { Component, Emit, Prop, Vue } from "vue-property-decorator";

@Component
export default class DriveItem extends Vue {
	@Prop() public id!: string;
	@Prop() public name!: string;
	@Prop() public webUrl!: string;
	@Prop() public downloadUrl!: string;
	@Prop() public deleteButtonVisible!: boolean;
	@Prop() public downloadButtonInvisible!: boolean;
	@Prop() public openBrowserButtonInvisible!: boolean;
	private url: string = '';
	@Emit("delete-drive-item")
	public deleteDriveItem(id: string) { }

	public created(): void {
		this.url = !this.openBrowserButtonInvisible ? this.webUrl : (!this.downloadButtonInvisible ? this.downloadUrl : '');
	}

	private onDownloadButtonClick(): void {
		window.open(this.downloadUrl);
	}

	private onOpenBrowserButtonClick(): void {
		window.open(this.webUrl);
	}

	private onDeleteButtonClick(): void {
		this.deleteDriveItem(this.id);
	}
}
